/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/hooks/softwareDiscoveryHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { SD_EXPERIMENT_USE_CASES } from '../../../constants/SoftwareDiscoveryConstants.migrated';
import { useAccounts } from '../../accounts';
const isExperimentUseCase = useCase => Object.values(SD_EXPERIMENT_USE_CASES).includes(useCase);
const generateLink = (prePath, postPath = '') => `${getFullUrl('app')}/${prePath}/${PortalIdParser.get()}/${postPath}`;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/hooks/softwareDiscoveryHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGetToolRecommendations = (useCases = [], contentLanguage) => {
  const {
    accounts,
    accountsLoading
  } = useAccounts();
  const userProduct = accounts && accounts.filter(account => account.id === PortalIdParser.get())[0];
  const checkForPaidUser = (enterpriseTier, proTier) => !!(userProduct && (userProduct.products.includes(enterpriseTier) || userProduct.products.includes(proTier)));
  const experimentUseCase = useCases.find(isExperimentUseCase);
  const isEnglishContent = !contentLanguage || contentLanguage.toUpperCase() === 'EN';
  switch (experimentUseCase) {
    case SD_EXPERIMENT_USE_CASES.MARKETING_LEAD_GEN:
      return {
        toolCardNames: ['add-on-ads', 'forms', 'add-on-reporting', 'social'],
        toolNames: ['Ads', 'Forms', 'Marketing Reporting', 'Social Media'],
        toolSlug: ['ads', 'forms', 'marketing-reporting', 'social-media'],
        toolLabelTitles: ['learningCenter.toolRecommendations.ads', 'learningCenter.toolRecommendations.forms', 'learningCenter.toolRecommendations.marketingReporting', 'learningCenter.toolRecommendations.socials'],
        practicalExerciseContentIds: isEnglishContent ? [null, 7826716, 7874892, 7863979] : [null, null, null, null],
        practicalExerciseLessonIds: isEnglishContent ? [null, 20644243, 21548556, 20502857] : [null, null, null, null],
        toolCardLinks: [generateLink('ads'), generateLink('forms'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('reports-list') : generateLink('pricing', 'upgrade/locked-nav-item?upgradeSource=marketing-reports-locked-nav-item'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('social', 'manage') : generateLink('pricing', 'upgrade/locked-nav-item?upgradeSource=social-media-locked-nav-item')],
        shortTitleKey: 'learningCenter.toolRecommendations.marketingLeadGen.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.marketingLeadGen.title',
        descriptionKey: 'learningCenter.toolRecommendations.marketingLeadGen.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    case SD_EXPERIMENT_USE_CASES.MARKETING_AUTOMATION:
      return {
        toolCardNames: ['successful-send', 'registration', 'workflows', 'multiple-inboxes'],
        toolNames: ['Email Marketing Tools', 'Lists', 'Workflows', 'Smart Campaigns'],
        toolSlug: ['email-marketing-tools', 'lists', 'workflows', 'smart-campaigns'],
        toolLabelTitles: ['learningCenter.toolRecommendations.emails', 'learningCenter.toolRecommendations.lists', 'learningCenter.toolRecommendations.workflows', 'learningCenter.toolRecommendations.smartCampaigns'],
        practicalExerciseContentIds: isEnglishContent ? [7829129, 8142986, 7825420, 7863973] : [null, null, null, null],
        practicalExerciseLessonIds: isEnglishContent ? [21548557, 21549147, 20646686, 19467143] : [null, null, null, null],
        toolCardLinks: [generateLink('email', 'manage/state/all'), generateLink('contacts', 'objectLists/views/all'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('workflows', 'view/default') : generateLink('pricing', 'upgrade/locked-nav-item?upgradeSource=workflows-locked-nav-item'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('marketing', 'campaigns/views/all') : generateLink('pricing', 'upgrade/locked-nav-item?upgradeSource=campaigns-locked-nav-item')],
        shortTitleKey: 'learningCenter.toolRecommendations.marketingAutomation.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.marketingAutomation.title',
        descriptionKey: 'learningCenter.toolRecommendations.marketingAutomation.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    case SD_EXPERIMENT_USE_CASES.SALES_PROSPECTING:
      return {
        toolCardNames: ['calling', 'leads', 'meetings-small', 'multiple-currency-revenue'],
        toolNames: ['Calling', 'Leads', 'Meetings', 'Create a Deal'],
        toolSlug: ['calling', 'leads', 'meetings', 'sales-reporting'],
        toolLabelTitles: ['learningCenter.toolRecommendations.calling', 'learningCenter.toolRecommendations.leads', 'learningCenter.toolRecommendations.meetings', 'learningCenter.toolRecommendations.createADeal'],
        practicalExerciseContentIds: isEnglishContent ? [8171535, 8251295, 8171538, 7828533] : [null, null, null, null],
        practicalExerciseLessonIds: isEnglishContent ? [21550928, 21549148, 21548558, 21548559] : [null, null, null, null],
        toolCardLinks: [checkForPaidUser('sales-enterprise-bundle', 'sales-pro-bundle') ? generateLink('settings', 'user-preferences/calling') : generateLink('pricing', 'upgrade?upgradeSource=calling-free-account-upgrade'), checkForPaidUser('sales-enterprise-bundle', 'sales-pro-bundle') ? generateLink('prospecting', 'leads') : generateLink('pricing', 'upgrade?upgradeSource=prospecting-workspace-leads'), generateLink('meetings'), checkForPaidUser('sales-enterprise-bundle', 'sales-pro-bundle') ? generateLink('reports-list', 'collections/sales') : generateLink('pricing', 'upgrade/locked-nav-item?upgradeSource=sales-performance-reports-locked-nav-item')],
        shortTitleKey: 'learningCenter.toolRecommendations.salesProspecting.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.salesProspecting.title',
        descriptionKey: 'learningCenter.toolRecommendations.salesProspecting.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    default:
      return undefined;
  }
};